var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./boxes-wrapper-new.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-27885ec0\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./boxes-wrapper-new.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/boxes-wrapper-new.vue
// module id = 336
// module chunks = 0